/**
* Created For: 公用搜索条
* this.$emit("input",val)  this.$emit("enter",this.keyword)  this.$emit("blur",this.keyword)
* Author: chenLiYan.
* Date: 2018/11/29 0029 16:07.
*/
<template>
  <label class="search-bar">
    <span class="sprite icon-search"></span>
    <input
      type="search"
      v-if="isFocus"
      class="search-input"
      v-focus
      v-model="keyword"
      :placeholder="placeholder"
      @keyup.enter="submitHandle"
      @blur="blurHandle" />
    <input
      type="text"
      v-else=""
      class="search-input"
      v-model="keyword"
      :placeholder="placeholder"
      @keyup.enter="submitHandle"
      @blur="blurHandle" />
    <input type="text" style="display: none"/>
    <span v-if="keyword && isShowClose" class="sprite icon-close" @click="keyword=''"></span>
  </label>
</template>

<script>
import { debounce } from '@/utils/utils' // 函数防抖，适用于输入
export default {
  name: 'SearchBar',
  components: {},
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    // 是否默认获取焦点
    isFocus: {
      type: Boolean,
      default: false
    },
    // 初始值
    defaultVal: {
      type: String,
      default: ''
    },
    // 是否显示清除值按钮
    isShowClose: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      keyword: ''
    }
  },
  computed: {},
  watch: {
    keyword: debounce(function (val) {
      this.$emit('input', val)
    }, 500),
    // 初始值变化时
    defaultVal (val) {
      this.keyword = val
    }
  },
  beforeMount () {
    this.keyword = this.defaultVal
  },
  methods: {
    // 回车事件
    submitHandle () {
      this.$emit('enter', this.keyword)
    },
    // 失去焦点时
    blurHandle () {
      this.$emit('blur', this.keyword)
    }
  }
}
</script>

<style lang="stylus" scoped>
    @import "../../stylus/base/base.styl"
    .search-bar{
        width 100%
        height 64px
        padding 0 88px
        background $color-gray
        position relative
        vertical-align: top
        overflow hidden
        .search-input{
            width 100%
            height 40px
            font-size $font-XL
            line-height 40px
            margin-top 12px
        }
        .sprite{
            position absolute
            top 50%
            transform translate(0,-50%)
            &.icon-search{
                left 21px
            }
            &.icon-close{
                right 21px
            }
        }
    }
</style>
